// externals
import type { Reducer } from 'redux';

// libraries
import type { DealXgDetailsState } from '@makemydeal/dr-dash-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { LINKS_SUCCESS, OFFER_SAVE_NOCHANGE_SUCCESS, OFFER_SAVE_SUCCESS, SOFT_SAVE_SUCCESS } from '../actionTypes/offerActionTypes';
import { SET_LOCK_PAYMENT_INPUTS_IN_SV } from '../actionTypes/dealLockingActionTypes';
import { UPDATE_OMS_ORDER_NUMBER } from '../actionTypes/socketActionTypes';
import { ECOMMERCE_ORDER_CLEARED } from '../types/orders';

const { INIT_PENCIL_SUCCESS } = initActionTypes;

export const dealXgDetailsInitialState: DealXgDetailsState = {
    globalCustomerId: '',
    lockCreditRatingAndTermsByDealType: {
        finance: false,
        lease: false
    }
};

export type DealXgDetailsReducer = Reducer<DealXgDetailsState>;

export const reducer: DealXgDetailsReducer = (state: DealXgDetailsState = dealXgDetailsInitialState, action: any) => {
    switch (action.type) {
        case INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                ...action.payload.dealXgDetails
            };
        }
        case LINKS_SUCCESS:
        case SOFT_SAVE_SUCCESS:
        case OFFER_SAVE_NOCHANGE_SUCCESS:
        case OFFER_SAVE_SUCCESS: {
            return state;
        }
        case UPDATE_OMS_ORDER_NUMBER: {
            // Update omsOrderNumber, tenantId, and orderDetailsLink from payload
            // Each field is optional and only updated if present in the payload
            return {
                ...state,
                ...(action.payload.omsOrderNumber && { omsOrderNumber: action.payload.omsOrderNumber }),
                ...(action.payload.tenantId && { tenantId: action.payload.tenantId }),
                ...(action.payload.orderDetailsLink && { orderDetailsLink: action.payload.orderDetailsLink })
            };
        }
        case ECOMMERCE_ORDER_CLEARED: {
            return { ...state, omsOrderNumber: '' };
        }
        case SET_LOCK_PAYMENT_INPUTS_IN_SV: {
            return {
                ...state,
                lockCreditRatingAndTermsByDealType: {
                    ...state.lockCreditRatingAndTermsByDealType,
                    ...action.payload
                }
            };
        }
        default: {
            return state;
        }
    }
};
